/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pink_Proof_Stork_StirInputs */

const en_pink_proof_stork_stir = /** @type {(inputs: Pink_Proof_Stork_StirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No reports found`)
};

const de_pink_proof_stork_stir = /** @type {(inputs: Pink_Proof_Stork_StirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Berichte gefunden`)
};

/**
* | output |
* | --- |
* | "No reports found" |
*
* @param {Pink_Proof_Stork_StirInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pink_proof_stork_stir = /** @type {((inputs?: Pink_Proof_Stork_StirInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pink_Proof_Stork_StirInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pink_proof_stork_stir(inputs)
	return de_pink_proof_stork_stir(inputs)
});